<template>
<div class="container-fluid d-flex flex-column h-100" v-if="$store.state.data.info.bibles.length">
  <div class="bible-open-head">
    <b-button variant="primary" @click="onClickOpen">
      <span v-if="indexes.book !== null">
        {{ book.toc2 }}
      </span>
      <span v-if="indexes.chapter !== null">
        {{ chapter.code }}
        {{ book.unit }}
      </span>
      を開く
    </b-button>
  </div>
  <div class="row no-gutters bible-open-body h-100">
    <b-card no-body class="w-100 h-100">
      <b-tabs card v-model="$store.state.ui.tabsBibleOpen.index">
        <b-tab title="訳" class="position-relative">
          <div class="row btn-group btn-group-tile btn-group-tile-3">
            <b-button variant="light"
              v-for="(item, index) in $store.state.data.info.bibles"
              class="text-center col-12"
              @click="onClickBible($event, item)"
              >
              {{ item.name }}
            </b-button>
          </div>
          <app-buy-layer ticket="premium" variant="light" />
        </b-tab>
        <b-tab title="書" active>
          <strong>旧約聖書</strong><br/>
          <div class="row btn-group btn-group-tile btn-group-tile-3">
            <b-button variant="light"
              v-for="(item, index) in bible.bible_books"
              class="text-center col-4 col-md-2"
              v-if="item.type === 'old'"
              @click="onClickBibleBook($event, item)"
              >
              {{ item.toc2 }}
            </b-button>
          </div>
          <br/>
          <br/>
          <strong>新約聖書</strong><br/>
          <div class="row btn-group btn-group-tile btn-group-tile-3">
            <b-button variant="light"
              v-for="(item, index) in bible.bible_books"
              class="text-center col-4 col-md-2"
              v-if="item.type === 'new'"
              @click="onClickBibleBook($event, item)"
              >
              {{ item.toc2 }}
            </b-button>
          </div>
          <br/>
          <br/>
          <template v-if="bible.apocrypha && $store.state.setting.apocrypha.value">
            <strong>旧約聖書続編</strong><br/>
            <div class="row btn-group btn-group-tile btn-group-tile-3">
              <b-button variant="light"
                v-for="(item, index) in bible.bible_books"
                class="text-center col-4 col-md-2"
                v-if="item.type === 'apo'"
                @click="onClickBibleBook($event, item)"
                >
                {{ item.toc2 }}
              </b-button>
            </div>
          </template>
        </b-tab>
        <b-tab title="章">
          <div class="row btn-group btn-group-tile btn-group-tile-5">
            <b-button variant="light"
              v-for="(item, index) in book.chapters"
              class="text-center col-5th"
              @click="onClickChapter($event, index)"
              >
              {{ item.code }}{{ book.unit }}
            </b-button>
          </div>
        </b-tab>
        <b-tab title="節">
          <div class="row btn-group btn-group-tile btn-group-tile-5">
            <b-button variant="light"
              v-for="(item, index) in chapter.verses"
              class="text-center col-5th"
              @click="onClickVerse($event, index)"
              >
              {{ item.code }}節
            </b-button>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</div>
</template>

<script>
import AppBuyLayer from '@/components/AppBuyLayer.vue'

export default {
  components: {
    AppBuyLayer,
  },
  data: function () {
    return {
      indexes: {
        bible: 0,
        book: 0,
        chapter: 0,
        verse: 0,
      },
      bible: {
      },
      book: {
      },
      chapter: {
        html: '',
        verses: [],
      },
    }
  },

  computed: {
  },

  methods: {
    onShown(event) {
      this.indexes.bible = this.$store.state.data.index.bible
      this.indexes.book = this.$store.state.data.index.book
      this.indexes.chapter = this.$store.state.data.index.chapter
      this.indexes.verse = this.$store.state.data.index.verse

      this.bible = this.$store.state.data.current.bible
      this.book = this.$store.state.data.current.book
      this.chapter = this.$store.state.data.current.chapter
      
      this.$store.dispatch('uiSetTabsBibleOpen', 1)

      if (this.$store.state.auth.ticket === 'basic' && this.indexes.bible !== 'SI') {
        for (var i = 0; i < this.$store.state.data.info.bibles.length; i++) {
          var item = this.$store.state.data.info.bibles[i]
          if (item.code === 'SI') {
            this.onClickBible(event, item)
            break;
          }
        }
      }
    },

    onClickOpen(event) {
      this.$store.dispatch(
        'dataBibleChapter',
        {
          bibleCode: this.indexes.bible,
          bookCode: this.indexes.book,
          chapterOrder: this.indexes.chapter,
          update: true,
        }
      ).then(response => {
        this.chapter = response.data
        this.onClickVerse(event, 0)
      })
    },

    onClickBible(event, item) {
      this.bible = item
      this.book = item.bible_books[0]
      this.chapter = item.bible_books[0].chapters[0]
        
      this.indexes.bible = item.code
      this.indexes.book = 'GEN'
      this.indexes.chapter = 0
      this.indexes.verse = 0
      this.$store.dispatch('uiSetTabsBibleOpen', 1)
    },

    onClickBibleBook(event, item) {
      this.book = item
      this.chapter = item.chapters[0]
        
      this.indexes.book = item.code
      this.indexes.chapter = 0
      this.indexes.verse = 0
      this.$store.dispatch('uiSetTabsBibleOpen', 2)
    },

    onClickChapter(event, index) {
      this.indexes.chapter = index
      this.indexes.verse = 0
      this.$store.dispatch(
        'dataBibleChapter',
        {
          bibleCode: this.bible.code,
          bookCode: this.book.code,
          chapterOrder: this.indexes.chapter,
          update: false,
        }
      ).then(response => {
        this.chapter = response.data
        this.$store.dispatch('uiSetTabsBibleOpen', 3)
      })
    },

    onClickVerse(event, index) {
      this.$store.dispatch('dataSetIndex', {
        indexes: {
          bible: this.bible.code,
          book: this.book.code,
          chapter: this.indexes.chapter,
          verse: index,
        },
        updateScroll: true,
      }).then(response => {
        this.$store.dispatch('uiToggleModalBibleBookOpen', false)
        this.$store.dispatch('dataSetChapter', this.chapter)
      })
    },
  },

  created: function() {
  },

  beforeDestroy: function () {
  }
}
</script>

<style lang="scss">
.bible-open-body {
  .tabs {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;

    .card-header {
      .nav-tabs {
        display: flex;

        li.nav-item {
          flex-grow: 1;

          a.nav-link {
            text-align: center;

            &.active {
              border-color: #dee2e6;
            }
          }
        }
      }
    }

    .tab-content {
      flex-grow: 1;
      overflow-y: scroll;

      .tab-pane {
        .row {
          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }
          
          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }
        }
      }
    }
  }
}
</style>
